import PropTypes from 'prop-types';

import Breadcrumb from 'shopper/components/Breadcrumb/V2';
import Icon from 'shopper/components/Icon';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const StoreBreadcrumb = ({ isOfferPage, storeName }) => (
  <Breadcrumb.Root>
    <Breadcrumb.Item
      aria-label="Ir para página inicial"
      icon={<Icon name="home" />}
      link={LINKS.HOME}
    />
    {isOfferPage ? (
      <Breadcrumb.Item link={LINKS.STORES}>
        {placeholder('breadcrumbs.stores')}
      </Breadcrumb.Item>
    ) : (
      <Breadcrumb.Item link={LINKS.COUPONS}>
        {placeholder('breadcrumbs.couponsHome')}
      </Breadcrumb.Item>
    )}

    <Breadcrumb.Item>{storeName}</Breadcrumb.Item>
  </Breadcrumb.Root>
);

StoreBreadcrumb.propTypes = {
  storeName: PropTypes.string.isRequired,
};

export default StoreBreadcrumb;
